import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: "root"
})
export class DashboardInformationService {
    dashboardInformationUrl = window.location.origin + '/api/v1.0/dashboardInformation/getDashboardInformation'; // 'https://localhost:44375/api/v1.0/dashboardInformation/getDashboardInformation';
    generateTokenUrl = window.location.origin + '/api/v1.0/tokenInformation/generateToken'; // 'https://localhost:44375/api/v1.0/tokenInformation/generateToken';
    constructor(private http: HttpClient) { }
    getDashboardInformation(): Observable<any> {
        // return this.http.post(this.configUrl);

         return this.http.get(this.dashboardInformationUrl);
    }

    generateToken(): Observable<any> {
        // return this.http.post(this.configUrl);

         return this.http.get(this.generateTokenUrl);
    }
    generateTokenP(): Promise<any> {       
        return this.http.get(this.generateTokenUrl).toPromise();
      }
}
